/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

import { css } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import {
	CopyLinkButton,
	EmbedPreview,
	IconTile,
	type LinkEmbedVariantProps,
	LoadingSkeleton,
	OpenLinkButton,
	TitleMeta,
} from './link-embed-shared';

const containerStyles = css({
	width: '100%',
	boxSizing: 'border-box',
	backgroundColor: token('elevation.surface.sunken'),
	borderRadius: token('radius.large'),
	overflow: 'hidden',
	paddingTop: token('space.200'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.150'),
});

const headerStyles = css({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.150'),
	paddingLeft: token('space.100'),
	paddingRight: token('space.100'),
});

const actionsStyles = css({
	display: 'flex',
	gap: token('space.100'),
});

export const LinkEmbedFull = ({
	url,
	title,
	provider,
	generatorName,
	iconUrl,
	previewHref,
	isLoading,
	isError,
	modifiedBy,
	updatedDate,
	secondsAgo,
	isOlderThanWeek,
}: LinkEmbedVariantProps): JSX.Element => (
	<div css={containerStyles}>
		{isLoading ? (
			<LoadingSkeleton />
		) : (
			<div css={headerStyles}>
				<IconTile iconUrl={iconUrl} isError={isError} generatorName={generatorName} />
				<TitleMeta
					title={title}
					provider={provider}
					updatedDate={updatedDate}
					secondsAgo={secondsAgo}
					isOlderThanWeek={isOlderThanWeek}
					modifiedBy={modifiedBy}
				/>
				<div css={actionsStyles}>
					<OpenLinkButton url={url} />
					<CopyLinkButton url={url} />
				</div>
			</div>
		)}
		{(isLoading || (!isError && previewHref)) && (
			<EmbedPreview url={url} previewHref={previewHref} isLoading={isLoading} />
		)}
	</div>
);
